<script setup>

</script>

<template>
    <td class="text-gray-900 font-light px-6 py-4"><slot/></td>
</template>
